import styled, { css } from 'styled-components';
import { BlankBtn } from 'components/Buttons';

interface CommentFormContainerProps {
  isResponseComponent: boolean;
}

export const CommentsContentWrapper = styled.div`
  width: 100%;
  margin-top: 80px;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    margin-bottom: 36px;
  }

  .comments-title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 30px;
  }

  h1 {
    color: var(--primary-color);
    font-size: var(--font-larger);
    font-family: 'Inter Bold';

    @media (max-width: 768px) {
    }
  }
`;

export const CommentFormContainer = styled.div<CommentFormContainerProps>`
  margin-bottom: 62px;
  ${({ isResponseComponent }) =>
    isResponseComponent &&
    css`
      margin-left: 5%;
    `}

  @media (max-width: 768px) {
    margin-bottom: 32px;
  }

  .btns-container {
    margin-top: 12px;
    display: flex;
    gap: 20px;
  }

  .input-container {
    width: 100%;
    display: flex;
    gap: 18px;

    img {
      width: 40px;
      height: 40px;
    }

    textarea {
      width: 100%;
      border-style: none;
      outline: none;
      resize: none;
      border-radius: 15px;
      background-color: var(--color-light-pink);
      padding: 15px;
    }
  }
`;

export const CommentCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .spacer {
    margin-bottom: 30px;
  }

  .container {
    display: flex;
    gap: 18px;
    background-color: var(--color-light-pink);
    border-radius: 15px;
    padding: 32px 15px 25px;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .avatar-container {
    width: 45px;
    height: 45px;
    background-color: var(--primary-color);
    border-radius: 12px;
    padding: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .profile-avatar {
    width: 100%;
    height: 100%;
    border-radius: 7px;
  }

  .comment-card {
    width: 100%;

    div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      position: relative;

      h2 {
        color: var(--color-text);
        font-size: var(--font-large);
        font-family: 'Inter Bold';
      }

      span {
        font-size: var(--font-small);
      }

      button {
        position: absolute;
        right: 0px;
        top: -20px;
        background-color: transparent;
        border: none;
        width: 12px;
        height: 12px;

        img {
          width: 100%;
          display: block;
        }
      }
    }

    p {
      font-size: var(--font-medium);
      white-space: pre-wrap;
    }
  }

  .list-responses {
    display: flex;
    flex-direction: column;
    margin-left: 5%;
    gap: 25px;

    @media (max-width: 768px) {
      margin-left: 7%;
    }
  }

  .btns-comment {
    button {
      color: var(--primary-color);
      opacity: 1;
    }
  }
`;

export const CommentBlankBtn = styled(BlankBtn)`
  height: 34px;
  padding: 0 25px;
`;
